
const SAFE_LOGO_PNG = require('./safe_logo.png');
const USDT_LOGO_PNG = require('./USDT.png');


export const SAFE_LOGO = SAFE_LOGO_PNG;
export const USDT_LOGO = USDT_LOGO_PNG;